<template>
  <ItineraryPageSection class="itinerary-introductory-section">
    <div class="description" v-html="itinerary.description" />

    <section class="emergency-contact" v-if="itinerary.liaison">
      <header class="emergency-contact__header">
        <h2 class="emergency-contact__title">Emergency contact</h2>
      </header>
      <div class="emergency-contact__info">
        <p>{{ itinerary.liaison.name }}</p>
        <p v-show="itinerary.liaison.phone">
          <a :href="`tel:${itinerary.liaison.phone}`">{{ itinerary.liaison.phone }}</a>
        </p>
        <p v-show="itinerary.liaison.email">
          <a :href="`mailto:${itinerary.liaison.email}`">{{ itinerary.liaison.email }}</a>
        </p>
      </div>
    </section>
  </ItineraryPageSection>
</template>

<script>
import ItineraryPageSection from '@/components/itinerary/ItineraryPageSection.vue';

export default {
  components: { ItineraryPageSection },
  props: {
    itinerary: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.itinerary-introductory-section {
  .description {
    margin-bottom: 24px;
    line-height: 24px;
    text-align: justify;
    font-size: 16px;

    ::v-deep {
      a {
        color: inherit;
        text-decoration: underline;
      }

      b,
      strong {
        font-weight: 600;
      }
    }
  }

  .emergency-contact {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 24px;

    @media (min-width: vars.$mobile-break-point + 1px) {
      gap: 40px;
    }

    &__header {
      padding: 12px 16px;
      text-align: center;
      border: 1px solid vars.$c-gray-da;
      background-color: vars.$c-total-white;
    }

    &__title {
      margin: 0;
      font-size: 16px;
      font-weight: 400;
    }

    &__info {
      flex: 1;
      font-size: 16px;
      line-height: 24px;

      & p {
        margin: 0;

        & a {
          color: vars.$c-dark-gray;
          overflow-wrap: break-word;
        }
      }
    }
  }
}
</style>
